import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { trackTransition } from '../../../../framework/store/FPTI/FPTIActions';
import './DeprecatedPage.less';
import { connect } from 'react-redux';
import RedirectButton from '../../../../shared-components/RedirectButton/RedirectButton';
import {REDIRECT_SUFFIX} from '../../../../framework/App/AppConstants';

const LOCALE_PREFIX = 'DE/pages/DeprecatedPage/DeprecatedPage';

export class GuestDeprecatedPage extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        onComponentDidMount: PropTypes.func.isRequired
    };
    static defaultProps = {
        onComponentDidMount: () => {}
    };
    componentDidMount() {
        this.props.onComponentDidMount();
    }
    render() {
        const { intl } = this.props;
        return (
            <div className="DeprecatedPageContainer">
                <div className="DeprecatedPageContent">
                    <div className="DeprecatedHeader">
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.deprecated-header`}
                        />
                    </div>
                    <div className="DeprecatedMessage">
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.deprecated-message`}
                        />
                    </div>
                </div>
                <div className="DeprecatedButtonContainer">
                    <RedirectButton
                        ctaLabel={intl.formatMessage({ id: `${LOCALE_PREFIX}.cta-button-label` })}
                        actionUri={REDIRECT_SUFFIX.CANCEL_REDIRECT}
                        className="errorReturnFlowAction DeprecatedButton"
                        buttonId="errorContinue"
                    />
                </div>
            </div>
        );
    }
}

export const mapStateToProps = state => ({});

export const mapDispatchToProps = dispatch => ({
    onComponentDidMount() {
        dispatch(trackTransition('pp_credit_deprecatedpage', 'prepare_pp_credit_deprecatedpage'));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(GuestDeprecatedPage));
